import { Icon } from "@iconify/react";

export default function ShowIcon({ icon, className = "h-6 w-6", ...props }) {
  return <Icon icon={icon} className={className} {...props} />;
}
